import { defineMessages } from "react-intl";

export default defineMessages({
  reviewedBy: {
    id: "recommendations.spCard.reviewedBy",
    defaultMessage: "Reviewed by {authorName}",
  },
  "categoryRecommendation.appliance-repairer": {
    id: "categoryRecommendation.appliance-repairer",
    defaultMessage:
      "Washing machine, dishwasher, fridge, oven repair, fault diagnosis...",
  },
  "categoryRecommendation.babysitter": {
    id: "categoryRecommendation.babysitter",
    defaultMessage: "Childcare, school pick-up, meals, homework help...",
  },
  "categoryRecommendation.bike-repairer": {
    id: "categoryRecommendation.bike-repairer",
    defaultMessage:
      "Bike repair, punctures, brake adjustment, full maintenance...",
  },
  "categoryRecommendation.bulky-item-removal": {
    id: "categoryRecommendation.bulky-item-removal",
    defaultMessage:
      "Furniture removal, green waste disposal, clearing out cellar or attic...",
  },
  "categoryRecommendation.carpenter": {
    id: "categoryRecommendation.carpenter",
    defaultMessage:
      "Custom furniture, parquet installation, doors, cupboards, wood repairs...",
  },
  "categoryRecommendation.cat-sitting": {
    id: "categoryRecommendation.cat-sitting",
    defaultMessage:
      "Home visits, feeding, litter cleaning, playtime and cuddles...",
  },
  "categoryRecommendation.delivery-person": {
    id: "categoryRecommendation.delivery-person",
    defaultMessage:
      "Parcel delivery, grocery shopping, furniture delivery, bulky transport...",
  },
  "categoryRecommendation.dog-sitting": {
    id: "categoryRecommendation.dog-sitting",
    defaultMessage: "Walking, home sitting, visits, daily care...",
  },
  "categoryRecommendation.electrician": {
    id: "categoryRecommendation.electrician",
    defaultMessage:
      "Installation of light fixtures, sockets, troubleshooting, compliance upgrades...",
  },
  "categoryRecommendation.english-classes": {
    id: "categoryRecommendation.english-classes",
    defaultMessage:
      "Conversation practice, grammar, tutoring, exam preparation...",
  },
  "categoryRecommendation.gardener": {
    id: "categoryRecommendation.gardener",
    defaultMessage: "Lawn mowing, hedge trimming, weeding, garden maintenance...",
  },
  "categoryRecommendation.handyman": {
    id: "categoryRecommendation.handyman",
    defaultMessage:
      "Small jobs, repairs, furniture assembly, curtain rod installation, sealing...",
  },
  "categoryRecommendation.home-assistant": {
    id: "categoryRecommendation.home-assistant",
    defaultMessage: "Cleaning, dusting, floors, kitchen, bathroom...",
  },
  "categoryRecommendation.home-hairdresser": {
    id: "categoryRecommendation.home-hairdresser",
    defaultMessage: "Haircut, blow-dry, coloring, home hairstyling...",
  },
  "categoryRecommendation.home-massage": {
    id: "categoryRecommendation.home-massage",
    defaultMessage: "Relaxing, sports or therapeutic massage at home...",
  },
  "categoryRecommendation.ironing": {
    id: "categoryRecommendation.ironing",
    defaultMessage: "Ironing shirts, household linen, careful folding...",
  },
  "categoryRecommendation.it-specialist": {
    id: "categoryRecommendation.it-specialist",
    defaultMessage:
      "PC/Mac troubleshooting, software installation, WiFi setup, virus removal...",
  },
  "categoryRecommendation.locksmith": {
    id: "categoryRecommendation.locksmith",
    defaultMessage:
      "Door opening, lock replacement, emergency repair, security upgrades...",
  },
  "categoryRecommendation.moving": {
    id: "categoryRecommendation.moving",
    defaultMessage:
      "Moving services, furniture transport, loading and unloading help...",
  },
  "categoryRecommendation.painter": {
    id: "categoryRecommendation.painter",
    defaultMessage:
      "Painting walls and ceilings, touch-ups, wallpapering, surface preparation...",
  },
  "categoryRecommendation.pet-sitting": {
    id: "categoryRecommendation.pet-sitting",
    defaultMessage: "Pet sitting, home visits, walks, daily care...",
  },
  "categoryRecommendation.piano-lessons": {
    id: "categoryRecommendation.piano-lessons",
    defaultMessage: "Beginner lessons, music theory, classical or modern pieces...",
  },
  "categoryRecommendation.plumber": {
    id: "categoryRecommendation.plumber",
    defaultMessage:
      "Water leak repair, drain unblocking, sanitary installation, boiler maintenance...",
  },
  "categoryRecommendation.private-lessons": {
    id: "categoryRecommendation.private-lessons",
    defaultMessage: "Tutoring, homework help, exam preparation...",
  },
  "categoryRecommendation.private-tutors": {
    id: "categoryRecommendation.private-tutors",
    defaultMessage: "Tutoring, homework help, exam preparation...",
  },
  "categoryRecommendation.seamstress": {
    id: "categoryRecommendation.seamstress",
    defaultMessage:
      "Clothing alterations, hemming, zipper replacement, adjustments...",
  },
  "categoryRecommendation.small-jobs": {
    id: "categoryRecommendation.small-jobs",
    defaultMessage:
      "Various jobs, IKEA assembly, wall mounting, sealing, adjustments...",
  },
});
